import isApiError from "@insite/client-framework/Common/isApiError";
import { get, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { RmaApiParameter, sendRmaRequestSubmit } from "@store/Services/EmailService";
import { RmaModel } from "@store/Types/ApiModels";

export async function rmaRequestSubmit(parameter: RmaApiParameter): Promise<ServiceResult<RmaModel>> {
    try {
        const rmaModel = await sendRmaRequestSubmit({ rmaModel: parameter.rmaModel });
        return {
            successful: true,
            result: rmaModel,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
